<template>
  <div class="pa-thumbnail-upload-button-field">
    <button
     type="submit"
     class="button"
     :class="additionalClass"
     :disabled="isDisabledButton"
     @click.prevent="handleUploadButton"
    >画像をアップロード</button>
    
    <input
     ref="fileUploadInput"
     type="file"
     value="Choose a file"
     accept="image/*"
     :disabled="isDisabledFileField"
     @change.prevent="handleFileUploadInputChange"
    />
  </div>
</template>

<script>
export default {
  props : {
    isDisabled : {
      default : false
    }
  },

  data(){
    return {
      additionalClass   : {
        'is-loading'  : false,
      },

      isLoading           : false,
      isDisabledButton    : false,
      isDisabledFileField : false,
    };
  },

  watch : {
    isDisabled : {
      handler(value){
        if(value === true){
          this.isDisabledButton     = true;
          this.isDisabledFileField  = true;
        }else{
          this.isDisabledButton     = false;
          this.isDisabledFileField  = false;
        }
      },
      immediate: true
    },

    isLoading : {
      handler(value){
        if(value === true){
          this.isDisabledButton = true;
          this.additionalClass['is-loading'] = true;
        }else{
          this.isDisabledButton = false;
          this.additionalClass['is-loading'] = false;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleUploadButton(){
      this.isDisabledFileField = false;
      
      this.$nextTick(() => {
        this.$refs.fileUploadInput.click();
      });
    },

    async handleFileUploadInputChange(event){
      this.isLoading = true;

      await this.UXWaiting(600);

      const files = event.target.files;
      
      if(files.length === 1){
        this.isLoading = false;
        
        this.$emit('onSelected', files[0]);
      }else{
        this.isLoading = false;
      }
    }
  }
}
</script>

<style lang="scss">
.pa-thumbnail-upload-button-field{
  button.button{
    display: block;
    margin:0;
    padding:0;
    width:100%;
    border-radius: 4px;
    background-color: #7A9997;
    border:1px solid #759593;
    color:#DEE6E5;
    font-size: 1rem;
    line-height: 1.6rem;
    font-weight: bold;
    height:inherit;

    &-disabled{
      color:#99B3B1;
      background-color: #829B9A;
      border:1px solid #7B9795;
    }
  }

  input[type="file"]{
    display:none;
  }
}
</style>